import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import AdminLayout from './components/layout/AdminLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import HeroPage from './pages/HeroPage';
import AboutPage from './pages/AboutPage';
import MusicPage from './pages/MusicPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import AnnouncementPage from './pages/AnnouncementPage';
import BeatsPage from './pages/BeatsPage';
import AlbumsPage from './pages/AlbumsPage';
import CollaboratorsPage from './pages/CollaboratorsPage';
import SocialLinksPage from './pages/SocialLinksPage';
import StatsPage from './pages/StatsPage';
import ReleasesPage from './pages/ReleasesPage';
import MediaLibraryPage from './pages/MediaLibraryPage';
import SettingsPage from './pages/SettingsPage';
import { Loading } from './components/ui';

const Protected: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0a0f' }}>
        <Loading />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
};

const router = createBrowserRouter([
  { path: '/admin/login', element: <LoginPage /> },
  {
    path: '/admin',
    element: (
      <Protected>
        <AdminLayout />
      </Protected>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'hero', element: <HeroPage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'music', element: <MusicPage /> },
      { path: 'services', element: <ServicesPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'announcement', element: <AnnouncementPage /> },
      { path: 'beats', element: <BeatsPage /> },
      { path: 'albums', element: <AlbumsPage /> },
      { path: 'collaborators', element: <CollaboratorsPage /> },
      { path: 'social-links', element: <SocialLinksPage /> },
      { path: 'stats', element: <StatsPage /> },
      { path: 'releases', element: <ReleasesPage /> },
      { path: 'media', element: <MediaLibraryPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
]);

const AdminRouter: React.FC = () => {
  return (
    <AuthProvider>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </AuthProvider>
  );
};

export default AdminRouter;
